export const NEWLY_REGISTERED_SATELLITE_BANNER_TEXT =
  'Thanks for registering as a Satellite during the current governance cycle. Please note that you are unable to vote, propose, or take part in any governance as a Satellite until the next governance cycle starts.'
